// src/components/NumericInput.tsx

import React from 'react';
import './NumericInput.scss';

interface NumericInputProps {
    label: string;
    minimum: number;
    maximum: number;
    increment?: number;
    value: number;
    onValueChange: (value: number) => void;
}

export const NumericInput: React.FC<NumericInputProps> = ({
    label,
    minimum,
    maximum,
    increment = 1,
    value,
    onValueChange
}) => {

    const roundToIncrement = (num: number): number => {
        return Math.round(num * 10) / 10;
    };

    return (
        <div className="control-group">
            <div className="number-input">
                <label>{label}</label>
                <button
                    onClick={() => onValueChange(roundToIncrement(Math.max(minimum, value - increment)))}
                    disabled={value <= minimum}
                >
                    -
                </button>
                <span>{value}</span>
                <button
                    onClick={() => onValueChange(roundToIncrement(Math.min(maximum, value + increment)))}
                    disabled={value >= maximum}
                >
                    +
                </button>
            </div>
        </div>
    );
};